import { useMutation } from "@1f/react-sdk";
import { verify_CF_ADE, verify_PIVA_ADE } from "../mutations/adeMutations";
import { apiErrorHelper } from "../helpers/apiErrorHelpers";
import { AnagraficaApi } from "./anagraficaApi";

export const AdeApi = () =>{

    const errorHelper = apiErrorHelper()
    const anagApi = AnagraficaApi()

    const apiVerifyCFFromAde = useMutation(
        verify_CF_ADE,
        { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const apiVerifyPIVAFromAde = useMutation(
        verify_PIVA_ADE,
        { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )

    const validateCFFromADE = async (codiceFiscale) => {
        try {
            const response = await apiVerifyCFFromAde.fetch(
                {
                    codiceFiscale: codiceFiscale
                }
            );            
            return response.data.data.validateCFFromADE;
        } catch (error) {
            let statusError = errorHelper.retriveErrorStatusCode(error);
            if(statusError && statusError !== 200){
                return { valido : await anagApi.VerifyCf(codiceFiscale), messaggio: "Codice fiscale non valido" }
            }
        }        
    }

    const validatePIVAFromADE = async (partitaIva) => {
        try {
            const response = await apiVerifyPIVAFromAde.fetch(            
                { partitaIva: partitaIva },
            );            
            return response.data.data.validatePIVAFromADE;
        } catch (error) {
            let statusError = errorHelper.retriveErrorStatusCode(error);
            if(statusError && statusError !== 200){
                return { valida : await anagApi.VerifyPIva(partitaIva) }
            }        
        }        
    }

    return {
        validateCFFromADE,
        validatePIVAFromADE
    }
}